(function () {
  "use strict";

  var PER_PAGE = 12;
  var cache = Object.create(null);
  var productCache = Object.create(null);
  var buyState = null;
  var cartQtyByVariant = Object.create(null);

  var INTRO_RE = [/snelle feiten/, /quick facts/, /wat is dit product/, /what is this product/];
  var DEEP_RE = [
    /samenstelling/,
    /composition/,
    /ingredi/,
    /ingredients/,
    /gebruik/,
    /directions/,
    /how to use/,
    /waarschuwing/,
    /warning/,
    /bewaren/,
    /storage/,
  ];

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function isEnglish() {
    var lang = (document.documentElement.lang || "").toLowerCase();
    if (lang.indexOf("en") === 0) return true;
    return (location.pathname || "").indexOf("/en/") === 0;
  }

  function stripLocalePrefix(pathname) {
    var p = String(pathname || "/");
    for (;;) {
      if (p === "/en" || p === "/nl") return "/";
      if (p.indexOf("/en/") === 0 || p.indexOf("/nl/") === 0) {
        p = p.slice(3) || "/";
        continue;
      }
      return p || "/";
    }
  }

  function withLocalePrefix(pathname, en) {
    var p = stripLocalePrefix(pathname);
    if (p.charAt(0) !== "/") p = "/" + p;
    if (!en) return p;
    return p === "/" ? "/en" : "/en" + p;
  }

  function localizeGuideUrl(url) {
    if (!url) return "";
    try {
      var u = new URL(url, location.origin);
      return withLocalePrefix(u.pathname, isEnglish());
    } catch (e) {
      return url;
    }
  }

  function localizeProductUrl(url, handle) {
    var path = "";
    if (url) {
      try {
        path = new URL(url, location.origin).pathname;
      } catch (e) {
        path = "";
      }
    }
    if (!path) return "";
    return withLocalePrefix(stripLocalePrefix(path), isEnglish());
  }

  function previewThemeId() {
    try {
      var id = new URLSearchParams(location.search).get("preview_theme_id") || "";
      if (!/^\d{6,20}$/.test(id)) {
        var rootEl = document.querySelector("[data-mpg-aio]");
        id =
          (rootEl &&
            (rootEl.getAttribute("data-mpg-aio-preview-theme-id") ||
              rootEl.getAttribute("data-mpg-aio-preview-theme-id-fallback"))) ||
          "";
      }
      return /^\d{6,20}$/.test(id) ? id : "";
    } catch (e) {
      return "";
    }
  }

  function withProductsReturn(url, state) {
    if (!url) return "";
    state = state || {};
    var preview = previewThemeId();
    try {
      var u = new URL(url, location.origin);
      if (u.origin !== location.origin) return url;
      u.searchParams.set("mpg_from", "products");
      if (state.product) u.searchParams.set("mpg_product", state.product);
      else u.searchParams.delete("mpg_product");
      if (state.page && Number(state.page) > 1) u.searchParams.set("mpg_page", String(state.page));
      else u.searchParams.delete("mpg_page");
      if (state.cat) u.searchParams.set("mpg_cat", state.cat);
      else u.searchParams.delete("mpg_cat");
      if (state.search) u.searchParams.set("mpg_search", state.search);
      else u.searchParams.delete("mpg_search");
      if (preview) u.searchParams.set("preview_theme_id", preview);
      return u.pathname + u.search + u.hash;
    } catch (err) {
      return url;
    }
  }

  function guideFetchUrl(row) {
    if (!row) return "";
    var handle = String(row.getAttribute("data-guide-handle") || "")
      .replace(/^\/+|\/+$/g, "")
      .replace(/^pages\//, "");
    if (handle) return withLocalePrefix("/pages/" + handle, isEnglish());
    return localizeGuideUrl(row.getAttribute("data-guide-url") || "");
  }

  function allInOnePath(en) {
    var path = stripLocalePrefix(location.pathname || "/");
    if (path.indexOf("productgids-overzicht") === -1) {
      path = "/pages/productgids-overzicht";
    }
    return withLocalePrefix(path, en);
  }

  function extractGuide(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var mpg =
      doc.querySelector("section.mpg") ||
      doc.querySelector(".mpg[data-muskle-pg-standard]") ||
      doc.querySelector("#MainContent .mpg") ||
      doc.querySelector("[data-muskle-pg-standard]");
    if (!mpg) return null;
    mpg.querySelectorAll("header-component, footer-component, #header-group, #footer-group, .shopify-section-group-header-group, .shopify-section-group-footer-group").forEach(function (el) {
      el.remove();
    });
    mpg.querySelectorAll("script").forEach(function (el) {
      if (el.getAttribute("data-mpg-pg-source") === "muskle_pg") return;
      el.remove();
    });
    mpg.querySelectorAll(".mpg__breadcrumb, nav.mpg__breadcrumb").forEach(function (el) {
      el.remove();
    });
    return mpg;
  }

  function parseProductgidsIsland(rootEl) {
    if (!rootEl || !rootEl.querySelector) return null;
    var island = rootEl.querySelector("[data-mpg-pg-source='muskle_pg']");
    if (!island) return null;
    var raw = (island.textContent || "").replace(/^\s+|\s+$/g, "");
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (!data || !data.handle) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function parseProductgidsTables(rootEl) {
    if (!rootEl || !rootEl.querySelector) return null;
    var facts = { handle: "", title: "", composition: [], ingredients: [], directions: "", warnings: "", storage: "", intro: "" };
    var comp = rootEl.querySelector("table.muskle-guide-table--composition");
    if (comp) {
      comp.querySelectorAll("tbody tr").forEach(function (tr) {
        var th = tr.querySelector("th");
        var tds = tr.querySelectorAll("td");
        facts.composition.push({
          label: ((th && th.textContent) || "").replace(/\s+/g, " ").trim(),
          per_serving: ((tds[0] && tds[0].textContent) || "").replace(/\s+/g, " ").trim(),
          per_100g: ((tds[1] && tds[1].textContent) || "").replace(/\s+/g, " ").trim(),
        });
      });
    }
    var ing = rootEl.querySelector("table.muskle-guide-table--ingredients");
    if (ing) {
      ing.querySelectorAll("tbody tr").forEach(function (tr) {
        var th = tr.querySelector("th");
        var td = tr.querySelector("td");
        facts.ingredients.push({
          label: ((th && th.textContent) || "").replace(/\s+/g, " ").trim(),
          value: ((td && td.textContent) || "").replace(/\s+/g, " ").trim(),
        });
      });
    }
    rootEl.querySelectorAll(".mpg-section").forEach(function (sec) {
      var title = sectionTitle(sec);
      var items = Array.prototype.map
        .call(sec.querySelectorAll("li, .mpg-section__body"), function (el) {
          return (el.textContent || "").replace(/\s+/g, " ").trim();
        })
        .filter(Boolean);
      var joined = items.join("\n");
      if (/^gebruik$|^directions$/.test(title)) facts.directions = joined;
      else if (/waarschuw|warning/.test(title)) facts.warnings = joined;
      else if (/bewaren|^storage$/.test(title)) facts.storage = joined;
      else if (/wat is dit product|what is this product/.test(title)) facts.intro = joined;
    });
    if (!facts.composition.length && !facts.ingredients.length && !facts.directions) return null;
    return facts;
  }

  function readProductgidsFacts(rootEl) {
    return parseProductgidsIsland(rootEl) || parseProductgidsTables(rootEl);
  }

  function sectionTitle(el) {
    var t = el.querySelector(".mpg-section__title, .mpg-faq__title, h2");
    return ((t && t.textContent) || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function matchesAny(text, regs) {
    return regs.some(function (re) {
      return re.test(text);
    });
  }

  function insertPointAfterIntro(mpg) {
    var inner = mpg.querySelector(".mpg__inner") || mpg;
    var rich = inner.querySelector(":scope > .mpg-richtext, :scope > .mpg-section.mpg-richtext");
    if (rich) return { parent: inner, before: rich.nextSibling };
    var children = Array.prototype.slice.call(inner.children);
    var lastIntro = inner.querySelector(":scope > .mpg-hero, :scope > .mpg-section--quick-facts");
    var firstDeep = null;
    children.forEach(function (sec) {
      if (sec.classList.contains("mpg-hero") || sec.classList.contains("mpg-section--quick-facts")) {
        lastIntro = sec;
        return;
      }
      var title = sectionTitle(sec);
      if (matchesAny(title, INTRO_RE)) lastIntro = sec;
      else if (!firstDeep && matchesAny(title, DEEP_RE)) firstDeep = sec;
    });
    if (lastIntro) return { parent: inner, before: lastIntro.nextSibling };
    if (firstDeep) return { parent: inner, before: firstDeep };
    return { parent: inner, before: inner.firstChild };
  }

  function insertPointBeforeClose(mpg) {
    var inner = mpg.querySelector(".mpg__inner") || mpg;
    var save = inner.querySelector(".mpg-save, [data-mpg-save-productgids]");
    if (save) return { parent: save.parentNode, before: save };
    var share = inner.querySelector(".mpg-cta, [data-mpg-share-block]");
    if (share) return { parent: share.parentNode, before: share };
    var pn = inner.querySelector(".mpg-pn, nav.mpg-pn");
    if (pn) return { parent: pn.parentNode, before: pn };
    var faq = inner.querySelector(".mpg-faq, .mpg-section.mpg-faq");
    if (faq) return { parent: faq.parentNode, before: faq.nextSibling };
    return { parent: inner, before: null };
  }

  function formatMoney(cents) {
    var amount = Number(cents) / 100;
    try {
      return new Intl.NumberFormat(isEnglish() ? "en-IE" : "nl-NL", {
        style: "currency",
        currency: "EUR",
      }).format(amount);
    } catch (e) {
      return "€" + amount.toFixed(2);
    }
  }

  function loadProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    var path = (isEnglish() ? "/en" : "") + "/products/" + encodeURIComponent(handle) + ".js";
    return fetch(path, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) {
        if (!res.ok) throw new Error("product " + res.status);
        return res.json();
      })
      .then(function (json) {
        productCache[handle] = json;
        return json;
      });
  }

  function firstAvailable(product) {
    var variants = (product && product.variants) || [];
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function variantById(product, id) {
    var variants = (product && product.variants) || [];
    var sid = String(id);
    var i;
    for (i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === sid) return variants[i];
    }
    return firstAvailable(product);
  }

  function varyingOption(product) {
    var opts = (product && product.options) || [];
    var varying = opts.filter(function (o) {
      return (o.values || []).length > 1;
    });
    return varying.length === 1 ? varying[0] : null;
  }

  function optionLabel(variant, option) {
    if (!variant || !option) return variant ? variant.title : "";
    var idx = (option.position || 1) - 1;
    return (variant.options && variant.options[idx]) || variant.title;
  }

  function variantImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return product.featured_image || "";
  }

  ready(function () {
    var root = document.querySelector("[data-mpg-aio]");
    if (!root) return;

    PER_PAGE = Number(root.getAttribute("data-per-page")) || 12;
    var defaultHandle = root.getAttribute("data-default-handle") || "";
    var loadingLabel = root.getAttribute("data-loading-label") || "";
    var errorLabel = root.getAttribute("data-error-label") || "";
    var copy = {
      mid: root.getAttribute("data-cta-mid") || "",
      end: root.getAttribute("data-cta-end") || "",
      atc: root.getAttribute("data-cta-atc") || "",
      sold: root.getAttribute("data-cta-sold") || "",
      view: root.getAttribute("data-cta-view") || "",
      qty: root.getAttribute("data-cta-qty") || "",
      stock: root.getAttribute("data-cta-stock") || "",
      variant: root.getAttribute("data-cta-variant") || "",
    };
    var ctaTemplate = root.querySelector("[data-mpg-aio-cta-template]");

    var rows = Array.prototype.slice.call(root.querySelectorAll("[data-mpg-aio-row]"));
    var catButtons = Array.prototype.slice.call(root.querySelectorAll("[data-mpg-aio-cat]"));
    var search = root.querySelector("[data-mpg-aio-search]");
    var reset = root.querySelector("[data-mpg-aio-reset]");
    var empty = root.querySelector("[data-mpg-aio-empty]");
    var pager = root.querySelector("[data-mpg-aio-pager]");
    var pageNums = root.querySelector("[data-mpg-aio-page-nums]");
    var prevBtn = root.querySelector("[data-mpg-aio-page-prev]");
    var nextBtn = root.querySelector("[data-mpg-aio-page-next]");
    var guideHost = root.querySelector("[data-mpg-aio-guide]");
    var statusEl = root.querySelector("[data-mpg-aio-guide-status]");
    var unfinishedEl = root.querySelector("[data-mpg-aio-unfinished]");
    var guideRoot = root.querySelector("[data-mpg-aio-guide-root]");

    var activeCat = "";
    var query = "";
    var page = 1;
    var selectedRow = null;
    var applyingUrl = false;
    var currentPgFacts = null;

    function readUrlState() {
      var params = new URLSearchParams(location.search);
      var rawPage = parseInt(params.get("mpg_page") || "", 10);
      return {
        product: params.get("mpg_product") || "",
        cat: params.get("mpg_cat") || "",
        page: rawPage >= 1 ? rawPage : 0,
        search: params.get("mpg_search") || "",
      };
    }

    function syncUrl(mode) {
      var next = new URL(location.href);
      var handle = selectedRow ? selectedRow.getAttribute("data-handle") || "" : "";
      if (handle) next.searchParams.set("mpg_product", handle);
      else next.searchParams.delete("mpg_product");
      if (activeCat) next.searchParams.set("mpg_cat", activeCat);
      else next.searchParams.delete("mpg_cat");
      if (page > 1) next.searchParams.set("mpg_page", String(page));
      else next.searchParams.delete("mpg_page");
      if (query) next.searchParams.set("mpg_search", query);
      else next.searchParams.delete("mpg_search");
      if (!next.searchParams.get("mpg_mode")) next.searchParams.set("mpg_mode", "producten");
      var url = next.pathname + next.search + next.hash;
      var current = location.pathname + location.search + location.hash;
      if (url === current) return;
      if (mode === "push") history.pushState({ mpgAio: true }, "", url);
      else history.replaceState({ mpgAio: true }, "", url);
    }

    function applyCategory(slug, resetPage) {
      activeCat = slug || "";
      catButtons.forEach(function (btn) {
        var on = (btn.getAttribute("data-mpg-aio-cat") || "") === activeCat;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (resetPage) page = 1;
      renderPager();
    }

    function findRow(handle) {
      if (!handle) return null;
      var i;
      for (i = 0; i < rows.length; i++) {
        if (rows[i].getAttribute("data-handle") === handle) return rows[i];
      }
      return null;
    }

    function matchingRows() {
      return rows.filter(function (row) {
        var cat = row.getAttribute("data-category") || "";
        var hay = ((row.getAttribute("data-title") || "") + " " + (row.getAttribute("data-vendor") || "")).toLowerCase();
        var catOk = !activeCat || cat === activeCat;
        var qOk = !query || hay.indexOf(query) !== -1;
        return catOk && qOk;
      });
    }

    function setCategory(slug) {
      applyCategory(slug, true);
      if (!applyingUrl) syncUrl("replace");
      syncGuidePrevNext(guideRoot);
    }

    function renderPager() {
      var matches = matchingRows();
      var totalPages = Math.max(1, Math.ceil(matches.length / PER_PAGE));
      if (page > totalPages) page = totalPages;
      if (page < 1) page = 1;

      rows.forEach(function (row) {
        var li = row.parentElement;
        if (li) li.hidden = true;
        row.hidden = true;
      });

      var start = (page - 1) * PER_PAGE;
      var visible = matches.slice(start, start + PER_PAGE);
      visible.forEach(function (row) {
        row.hidden = false;
        if (row.parentElement) row.parentElement.hidden = false;
      });

      if (empty) empty.classList.toggle("is-visible", matches.length === 0);
      if (pager) pager.hidden = matches.length === 0 || totalPages <= 1;

      if (pageNums) {
        pageNums.innerHTML = "";
        for (var i = 1; i <= totalPages; i++) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "mpg-aio-chrome__pagenum" + (i === page ? " is-active" : "");
          btn.textContent = String(i);
          btn.setAttribute("data-mpg-aio-page", String(i));
          btn.setAttribute("aria-current", i === page ? "page" : "false");
          pageNums.appendChild(btn);
        }
      }
      if (prevBtn) prevBtn.disabled = page <= 1;
      if (nextBtn) nextBtn.disabled = page >= totalPages;
    }

    function showPageForRow(row) {
      var matches = matchingRows();
      var idx = matches.indexOf(row);
      if (idx < 0) return;
      page = Math.floor(idx / PER_PAGE) + 1;
      renderPager();
    }

    function setStatus(text, show) {
      if (!statusEl) return;
      statusEl.textContent = text || "";
      statusEl.hidden = !show;
    }

    function clearGuide() {
      if (guideRoot) guideRoot.innerHTML = "";
      buyState = null;
    }

    function currentCtas() {
      return guideRoot ? Array.prototype.slice.call(guideRoot.querySelectorAll("[data-mpg-aio-cta]")) : [];
    }

    function applyCart(cart) {
      cartQtyByVariant = Object.create(null);
      var items = (cart && cart.items) || [];
      items.forEach(function (item) {
        var id = String(item.variant_id || item.id || "");
        var qty = Number(item.quantity) || 0;
        if (!id || qty <= 0) return;
        cartQtyByVariant[id] = (cartQtyByVariant[id] || 0) + qty;
      });
    }

    function variantInCart(variantId) {
      return (Number(cartQtyByVariant[String(variantId)] || 0) > 0);
    }

    function refreshCart() {
      return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          applyCart(cart);
          paintCtas();
          return cart;
        })
        .catch(function () {
          return null;
        });
    }

    function paintCtas(nodes) {
      if (!buyState || !buyState.product) return;
      var product = buyState.product;
      var variant = variantById(product, buyState.variantId);
      var available = !!(variant && variant.available);
      var img = variantImage(product, variant);
      var chosen = variant ? variant.public_title || variant.title : "";
      var needsSelect = ((product.variants || []).length > 1);
      var vary = varyingOption(product);
      var ctas = nodes && nodes.length ? nodes : currentCtas();

      ctas.forEach(function (cta) {
        var imgEl = cta.querySelector("[data-cta-img]");
        var titleEl = cta.querySelector("[data-cta-title]");
        var chosenEl = cta.querySelector("[data-cta-chosen]");
        var priceEl = cta.querySelector("[data-cta-price]");
        var compareEl = cta.querySelector("[data-cta-compare]");
        var availEl = cta.querySelector("[data-cta-avail]");
        var wrap = cta.querySelector("[data-cta-variant-wrap]");
        var select = cta.querySelector("[data-cta-variant-select]");
        var qty = cta.querySelector("[data-cta-qty]");
        var atc = cta.querySelector("[data-cta-atc]");
        var view = cta.querySelector("[data-cta-view]");
        if (imgEl) {
          imgEl.src = img;
          imgEl.alt = product.title || "";
        }
        if (titleEl) titleEl.textContent = product.title || "";
        if (chosenEl) {
          chosenEl.textContent = needsSelect ? chosen : "";
          chosenEl.hidden = !needsSelect;
        }
        if (priceEl && variant) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          var compare = variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price);
          compareEl.hidden = !compare;
          compareEl.textContent = compare ? formatMoney(variant.compare_at_price) : "";
        }
        if (availEl) availEl.textContent = available ? copy.stock : copy.sold;
        if (wrap) wrap.hidden = !needsSelect;
        if (select && needsSelect && select.options.length === 0) {
          (product.variants || []).forEach(function (v) {
            var opt = document.createElement("option");
            opt.value = String(v.id);
            opt.textContent = (vary ? optionLabel(v, vary) : v.title) + (v.available ? "" : " — " + copy.sold);
            opt.setAttribute("data-available", v.available ? "true" : "false");
            select.appendChild(opt);
          });
        }
        if (select) select.value = String(buyState.variantId);
        if (qty && String(qty.value) !== String(buyState.quantity)) qty.value = String(buyState.quantity);
        if (atc) {
          atc.disabled = !available;
          atc.textContent = available ? copy.atc : copy.sold;
          var inCart = !!(available && variant && variantInCart(variant.id));
          atc.classList.toggle("mpg-aio-buy__atc--in-cart", inCart);
        }
        if (view) {
          var productHref = localizeProductUrl(product.url, product.handle);
          view.href = withProductsReturn(productHref, {
            product: product.handle || "",
            page: page,
            cat: activeCat,
            search: query,
          });
          view.textContent = copy.view;
        }
      });
    }

    function addToCart() {
      if (!buyState || !buyState.variantId) return Promise.resolve();
      var variant = variantById(buyState.product, buyState.variantId);
      if (!variant || !variant.available) return Promise.resolve();
      var formData = new FormData();
      formData.set("id", String(buyState.variantId));
      formData.set("quantity", String(buyState.quantity || 1));
      var sectionIds = [];
      document.querySelectorAll("cart-items-component").forEach(function (item) {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });
      if (sectionIds.length) formData.append("sections", sectionIds.join(","));
      var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || "/cart/add.js";
      currentCtas().forEach(function (cta) {
        var btn = cta.querySelector("[data-cta-atc]");
        if (btn) btn.disabled = true;
        var err = cta.querySelector("[data-cta-error]");
        if (err) err.hidden = true;
      });
      return fetch(url, {
        method: "POST",
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        body: formData,
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var json = null;
            try {
              json = text ? JSON.parse(text) : null;
            } catch (e) {
              json = null;
            }
            return { ok: res.ok, json: json };
          });
        })
        .then(function (pack) {
          var failed =
            !pack.ok || (pack.json && pack.json.status && (pack.json.description || pack.json.message));
          if (failed) {
            currentCtas().forEach(function (cta) {
              var err = cta.querySelector("[data-cta-error]");
              if (err) {
                err.hidden = false;
                err.textContent =
                  (pack.json && (pack.json.description || pack.json.message)) || errorLabel;
              }
            });
            paintCtas();
            return;
          }
          return fetch("/cart.js", { credentials: "same-origin" })
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              applyCart(cart);
              document.dispatchEvent(
                new CustomEvent("cart:update", {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    sourceId: "mpg-aio-cta",
                    data: {
                      source: "product-form-component",
                      itemCount: Number(buyState.quantity) || 1,
                      productId: String(buyState.product.id),
                      variantId: String(buyState.variantId),
                      sections: pack.json && pack.json.sections,
                    },
                  },
                })
              );
              paintCtas();
            });
        })
        .catch(function () {
          currentCtas().forEach(function (cta) {
            var err = cta.querySelector("[data-cta-error]");
            if (err) {
              err.hidden = false;
              err.textContent = errorLabel;
            }
          });
          paintCtas();
        });
    }

    function bindCtaEvents(cta) {
      var select = cta.querySelector("[data-cta-variant-select]");
      var qty = cta.querySelector("[data-cta-qty]");
      var atc = cta.querySelector("[data-cta-atc]");
      if (select) {
        select.addEventListener("change", function () {
          if (!buyState) return;
          buyState.variantId = select.value;
          paintCtas();
        });
      }
      if (qty) {
        qty.addEventListener("input", function () {
          if (!buyState) return;
          var n = parseInt(qty.value, 10);
          if (!n || n < 1) n = 1;
          buyState.quantity = n;
          paintCtas();
        });
      }
      if (atc) {
        atc.addEventListener("click", function () {
          addToCart();
        });
      }
    }

    function cloneCta(slot, heading) {
      if (!ctaTemplate || !ctaTemplate.content) return null;
      var node = ctaTemplate.content.firstElementChild.cloneNode(true);
      node.setAttribute("data-cta-slot", slot);
      var h = node.querySelector("[data-cta-heading]");
      if (h) h.textContent = heading;
      var qtyLabel = node.querySelector("[data-cta-qty-label]");
      if (qtyLabel) qtyLabel.textContent = copy.qty;
      var vLabel = node.querySelector("[data-cta-variant-label]");
      if (vLabel) vLabel.textContent = copy.variant;
      var atc = node.querySelector("[data-cta-atc]");
      if (atc) atc.textContent = copy.atc;
      var view = node.querySelector("[data-cta-view]");
      if (view) view.textContent = copy.view;
      bindCtaEvents(node);
      return node;
    }

    function injectCtas(mpg, product) {
      if (!mpg || !product || !ctaTemplate) return;
      if (!((product.variants || []).length)) return;
      var mid = cloneCta("mid", copy.mid);
      var end = cloneCta("end", copy.end);
      var midAt = insertPointAfterIntro(mpg);
      var endAt = insertPointBeforeClose(mpg);
      if (mid && midAt.parent) midAt.parent.insertBefore(mid, midAt.before);
      if (end && endAt.parent) endAt.parent.insertBefore(end, endAt.before);
      var first = firstAvailable(product);
      buyState = {
        product: product,
        variantId: first ? String(first.id) : "",
        quantity: 1,
      };
      paintCtas([mid, end].filter(Boolean));
      if (selectedRow) {
        var guidePath = selectedRow.getAttribute("data-guide-url") || "";
        if (guidePath) {
          var guideHref = withProductsReturn(localizeGuideUrl(guidePath), {
            product: selectedRow.getAttribute("data-handle") || "",
            page: page,
            cat: activeCat,
            search: query,
          });
          [mid, end].filter(Boolean).forEach(function (cta) {
            if (!cta || cta.querySelector("[data-cta-guide]")) return;
            var actions = cta.querySelector(".mpg-aio-buy__actions");
            if (!actions) return;
            var a = document.createElement("a");
            a.className = "mpg-btn mpg-btn--secondary mpg-aio-buy__guide";
            a.setAttribute("data-cta-guide", "");
            a.href = guideHref;
            a.textContent = isEnglish() ? "Read Product Guide" : "Lees Productgids";
            actions.appendChild(a);
          });
        }
      }
    }

    function polishLangSwitch(scope) {
      if (!scope) return;
      var wrap = scope.querySelector(".mpg-lang-switch");
      var link = wrap && wrap.querySelector("a");
      if (!link) return;
      wrap.classList.add("mpg-aio-lang");
      link.classList.add("mpg-aio-lang__btn");
      link.textContent = isEnglish() ? "NL · Nederlands" : "EN · English";
    }

    function injectBackToTop(scope) {
      if (!scope || scope.querySelector("[data-mpg-aio-top]")) return;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "mpg-aio-top";
      btn.setAttribute("data-mpg-aio-top", "");
      btn.textContent = isEnglish() ? "↑ Back to top" : "↑ Naar boven";
      var pn = scope.querySelector(".mpg-pn, nav.mpg-pn");
      var footer = scope.querySelector(".mpg-footer");
      if (pn && pn.parentNode) {
        pn.parentNode.insertBefore(btn, pn.nextSibling);
      } else if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(btn, footer);
      } else {
        (scope.querySelector(".mpg__inner") || scope).appendChild(btn);
      }
    }

    function scrollToSelector() {
      var target = root.querySelector(".mpg-aio-chrome__layout") || root.querySelector("[data-mpg-aio-filters]");
      if (!target || !target.scrollIntoView) return;
      var reduce = false;
      try {
        reduce = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
      } catch (e) {}
      target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    }

    function neighborInPool(dir) {
      var pool = matchingRows();
      var idx = selectedRow ? pool.indexOf(selectedRow) : -1;
      if (idx < 0) return null;
      if (dir === "prev") return idx > 0 ? pool[idx - 1] : null;
      if (dir === "next") return idx < pool.length - 1 ? pool[idx + 1] : null;
      return null;
    }

    function makePnButton(dir) {
      var btn = document.createElement("a");
      btn.className = "mpg-pn__btn mpg-pn__btn--" + dir;
      btn.setAttribute("data-mpg-pn-dir", dir);
      btn.setAttribute("href", "#MpgAioSelectedGuide");
      var label = document.createElement("span");
      label.className = "mpg-pn__label";
      label.textContent =
        dir === "prev"
          ? isEnglish()
            ? "← Previous Product Guide"
            : "← Vorige Productgids"
          : isEnglish()
            ? "Next Product Guide →"
            : "Volgende Productgids →";
      var accent = document.createElement("span");
      accent.className = "mpg-pn__accent";
      accent.setAttribute("aria-hidden", "true");
      if (dir === "prev") {
        btn.appendChild(accent);
        btn.appendChild(label);
      } else {
        btn.appendChild(label);
        btn.appendChild(accent);
      }
      return btn;
    }

    function ensureGuidePrevNext(scope) {
      if (!scope) return null;
      var pool = matchingRows();
      if (pool.length < 2) {
        var existing = scope.querySelector(".mpg-pn");
        if (existing) existing.hidden = true;
        return null;
      }
      var nav = scope.querySelector(".mpg-pn, nav.mpg-pn");
      if (!nav) {
        nav = document.createElement("nav");
        nav.className = "mpg-pn";
        nav.setAttribute(
          "aria-label",
          isEnglish() ? "Product guide navigation" : "Productgids navigatie"
        );
        var wrap = document.createElement("div");
        wrap.className = "mpg-pn__row";
        nav.appendChild(wrap);
        var host = scope.querySelector(".mpg__inner") || scope;
        host.appendChild(nav);
      }
      nav.hidden = false;
      var row = nav.querySelector(".mpg-pn__row") || nav;
      if (!nav.querySelector("[data-mpg-pn-dir='prev']")) {
        row.insertBefore(makePnButton("prev"), row.firstChild);
      }
      if (!nav.querySelector("[data-mpg-pn-dir='next']")) {
        row.appendChild(makePnButton("next"));
      }
      return nav;
    }

    function syncGuidePrevNext(scope) {
      if (!scope) return;
      var pool = matchingRows();
      var nav = ensureGuidePrevNext(scope);
      if (!nav) return;
      var idx = selectedRow ? pool.indexOf(selectedRow) : -1;
      var prevRow = idx > 0 ? pool[idx - 1] : null;
      var nextRow = idx >= 0 && idx < pool.length - 1 ? pool[idx + 1] : null;
      var prevBtn = nav.querySelector("[data-mpg-pn-dir='prev']");
      var nextBtn = nav.querySelector("[data-mpg-pn-dir='next']");
      var row = nav.querySelector(".mpg-pn__row");

      function applyBtn(btn, target) {
        if (!btn) return;
        if (!target) {
          btn.hidden = true;
          btn.setAttribute("aria-disabled", "true");
          btn.removeAttribute("href");
          btn.setAttribute("tabindex", "-1");
          btn.removeAttribute("data-mpg-pn-handle");
        } else {
          btn.hidden = false;
          btn.removeAttribute("aria-disabled");
          btn.setAttribute("href", "#MpgAioSelectedGuide");
          btn.removeAttribute("tabindex");
          btn.setAttribute("data-mpg-pn-handle", target.getAttribute("data-guide-handle") || "");
        }
      }

      applyBtn(prevBtn, prevRow);
      applyBtn(nextBtn, nextRow);
      if (row) {
        row.classList.toggle("mpg-pn__row--next-only", !prevRow && !!nextRow);
        row.classList.toggle("mpg-pn__row--prev-only", !!prevRow && !nextRow);
      }
    }

    function bindGuideInteractions(scope) {
      if (!scope || scope.getAttribute("data-mpg-aio-bound") === "1") return;
      scope.setAttribute("data-mpg-aio-bound", "1");
      scope.addEventListener(
        "click",
        function (event) {
        var copyBtn = event.target.closest("[data-mpg-share-copy]");
        if (copyBtn) {
          event.preventDefault();
          var url = copyBtn.getAttribute("data-mpg-url") || window.location.href;
          var done = copyBtn.getAttribute("data-mpg-done") || "OK";
          var status = scope.querySelector("[data-mpg-share-status]");
          var write =
            navigator.clipboard && navigator.clipboard.writeText
              ? navigator.clipboard.writeText(url)
              : Promise.reject();
          write
            .catch(function () {
              window.prompt(done, url);
            })
            .then(function () {
              if (!status) return;
              status.hidden = false;
              status.textContent = done;
              window.setTimeout(function () {
                status.hidden = true;
              }, 2500);
            });
          return;
        }

        var topBtn = event.target.closest("[data-mpg-aio-top]");
        if (topBtn) {
          event.preventDefault();
          event.stopPropagation();
          scrollToSelector();
          return;
        }

        var langLink = event.target.closest(".mpg-lang-switch a, .mpg-aio-lang__btn");
        if (langLink) {
          event.preventDefault();
          event.stopPropagation();
          switchAllInOneLocale(!isEnglish());
          return;
        }

        var pn = event.target.closest("a.mpg-pn__btn, [data-mpg-pn-dir]");
        if (!pn) return;
        event.preventDefault();
        event.stopPropagation();
        if (pn.hidden || pn.getAttribute("aria-disabled") === "true") return;
        var dir =
          pn.getAttribute("data-mpg-pn-dir") ||
          (pn.classList.contains("mpg-pn__btn--prev") ? "prev" : "next");
        var next = neighborInPool(dir);
        if (!next) return;
        selectRow(next, { history: "push" });
      },
        true
      );
    }

    function switchAllInOneLocale(wantEn) {
      syncUrl("replace");
      var target = allInOnePath(wantEn) + (location.search || "");
      var prefix = wantEn ? "en" : "nl";
      var opt =
        document.querySelector('[data-muskle-market-language][data-muskle-market-lang-prefix="' + prefix + '"]') ||
        document.querySelector('[data-muskle-lang-option][data-muskle-lang-prefix="' + prefix + '"]');
      var form =
        (opt && opt.closest("form")) ||
        document.querySelector("[data-muskle-market-language-switcher] form") ||
        document.querySelector("[data-muskle-language-switcher] form") ||
        document.querySelector('form[action="/localization"]');
      if (form) {
        var langInput = form.querySelector("[data-muskle-market-lang-input], [data-muskle-lang-input], [name='language_code']");
        var returnInput = form.querySelector("[name='return_to']");
        var languageCode =
          (opt && (opt.getAttribute("data-muskle-market-language") || opt.getAttribute("data-muskle-lang-option"))) ||
          prefix;
        if (langInput) langInput.value = languageCode;
        if (returnInput) returnInput.value = target;
        form.submit();
        return;
      }
      location.assign(target);
    }

    function loadGuide(row) {
      if (!row) return;
      currentPgFacts = null;
      var readyGuide = row.getAttribute("data-guide-ready") === "1";
      var url = guideFetchUrl(row);
      var handle = row.getAttribute("data-handle") || "";
      if (unfinishedEl) unfinishedEl.hidden = true;
      clearGuide();

      if (!readyGuide || !url) {
        setStatus("", false);
        if (unfinishedEl) {
          unfinishedEl.hidden = false;
          syncGuidePrevNext(unfinishedEl);
        }
        return;
      }

      setStatus(loadingLabel, true);
      function fetchGuide(target) {
        return fetch(target, { credentials: "same-origin", headers: { Accept: "text/html" } }).then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        });
      }
      var guidePromise = cache[url]
        ? Promise.resolve(cache[url])
        : fetchGuide(url).catch(function () {
            return new Promise(function (resolve, reject) {
              window.setTimeout(function () {
                fetchGuide(url).then(resolve, reject);
              }, 900);
            });
          });

      Promise.all([guidePromise, loadProductJson(handle).catch(function () {
        return null;
      })])
        .then(function (pack) {
          var html = pack[0];
          var product = pack[1];
          if (selectedRow !== row) return;
          var node = extractGuide(html);
          setStatus("", false);
          if (!node || !guideRoot) {
            setStatus(errorLabel, true);
            return;
          }
          cache[url] = html;
          guideRoot.innerHTML = "";
          var imported = document.importNode(node, true);
          guideRoot.appendChild(imported);
          currentPgFacts = readProductgidsFacts(imported) || readProductgidsFacts(node);
          if (window.MuskleMilo && typeof window.MuskleMilo.setProductContext === "function" && selectedRow) {
            window.MuskleMilo.setProductContext({
              handle: selectedRow.getAttribute("data-handle") || "",
              title: selectedRow.getAttribute("data-title") || "",
              productgids: currentPgFacts,
            });
          }
          injectCtas(imported, product);
          polishLangSwitch(imported);
          injectBackToTop(imported);
          bindGuideInteractions(guideHost || guideRoot);
          syncGuidePrevNext(imported);
        })
        .catch(function () {
          if (selectedRow !== row) return;
          setStatus(errorLabel, true);
        });
    }

    function updateMiloContext(row) {
      var box = root.querySelector("[data-mpg-aio-milo-context]");
      var name = root.querySelector("[data-mpg-aio-milo-product]");
      var img = root.querySelector("[data-mpg-aio-milo-image]");
      if (!box || !name) return;
      var title = row ? row.getAttribute("data-title") || "" : "";
      var image = row ? row.getAttribute("data-image") || "" : "";
      var handle = row ? row.getAttribute("data-handle") || "" : "";
      name.textContent = title;
      box.hidden = !title;
      if (img) {
        if (image) {
          img.src = image;
          img.alt = title;
          img.hidden = false;
        } else {
          img.removeAttribute("src");
          img.alt = "";
          img.hidden = true;
        }
      }
      if (window.MuskleMilo && typeof window.MuskleMilo.setProductContext === "function") {
        window.MuskleMilo.setProductContext({
          handle: handle,
          title: title,
          productgids: currentPgFacts,
        });
      }
    }

    function miloNote(text) {
      var thread = root.querySelector("[data-mpg-aio-milo-thread]");
      if (!thread || !text) return;
      var p = document.createElement("p");
      p.className = "mpg-aio-milo__note";
      p.textContent = text;
      thread.appendChild(p);
      thread.scrollTop = thread.scrollHeight;
    }

    function scrollToGuideTopic(topic) {
      if (!guideRoot) return false;
      var patterns = {
        usage: /gebruik|directions|how to use|usage|dosering/i,
        ingredients: /ingredi|samenstelling|composition|ingredients/i,
        nutrition: /voedings|nutrition|eiwit|kcal|nutrition facts/i,
        warnings: /waarschuw|warning|veilig|safety/i,
      };
      var re = patterns[topic];
      if (!re) return false;
      var heads = guideRoot.querySelectorAll("h1, h2, h3, h4, .mpg-h2, .mpg-h3, [data-mpg-heading]");
      for (var i = 0; i < heads.length; i++) {
        if (re.test((heads[i].textContent || "").replace(/\s+/g, " "))) {
          heads[i].scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
      }
      if (guideHost) guideHost.scrollIntoView({ behavior: "smooth", block: "start" });
      return true;
    }

    function bindMilo() {
      var milo = root.querySelector("[data-mpg-aio-milo]");
      if (!milo) return;
      var toggle = milo.querySelector("[data-mpg-aio-milo-toggle]");
      var body = milo.querySelector("[data-mpg-aio-milo-body]");
      var input = milo.querySelector("[data-mpg-aio-milo-input]");
      var send = milo.querySelector("[data-mpg-aio-milo-send]");
      var thread = milo.querySelector("[data-mpg-aio-milo-thread]");
      var statusEl = milo.querySelector("[data-mpg-aio-milo-status]");
      var errorLabel = root.getAttribute("data-milo-error") || "";
      var unavailableLabel = root.getAttribute("data-milo-unavailable") || "";
      var changedLabel = root.getAttribute("data-milo-changed") || "";
      var lastHandle = "";
      var asking = false;

      var CHIP_Q = {
        usage: root.getAttribute("data-milo-q-usage") || "",
        ingredients: root.getAttribute("data-milo-q-ingredients") || "",
        nutrition: root.getAttribute("data-milo-q-nutrition") || "",
        warnings: root.getAttribute("data-milo-q-warnings") || "",
        allergens: root.getAttribute("data-milo-q-allergens") || "",
      };
      var COPY = {
        allergenUnknown: root.getAttribute("data-milo-copy-allergen-unknown") || "",
        flavour: root.getAttribute("data-milo-copy-flavour") || "",
        nutritionLimited: root.getAttribute("data-milo-copy-nutrition-limited") || "",
        catalogNote: root.getAttribute("data-milo-copy-catalog-note") || "",
        catalogBlocked: root.getAttribute("data-milo-copy-catalog-blocked") || "",
        available: root.getAttribute("data-milo-copy-available") || "",
        match: root.getAttribute("data-milo-copy-match") || "",
      };

      function setMiloStatus(state) {
        if (!statusEl) return;
        statusEl.classList.toggle("is-ready", state === "ready");
        statusEl.classList.toggle("is-error", state === "error");
      }

      function miloNote(text, kind) {
        if (!thread || !text) return;
        var p = document.createElement("p");
        p.className = "mpg-aio-milo__note" + (kind ? " mpg-aio-milo__note--" + kind : "");
        p.textContent = text;
        thread.appendChild(p);
        thread.scrollTop = thread.scrollHeight;
      }

      function catalogItem(row) {
        if (!row) return null;
        var priceRaw = row.getAttribute("data-price-min") || "";
        var price = priceRaw === "" ? null : Number(priceRaw);
        if (price != null && !isFinite(price)) price = null;
        return {
          row: row,
          handle: row.getAttribute("data-handle") || "",
          title: row.getAttribute("data-title") || "",
          vendor: row.getAttribute("data-vendor") || "",
          category: row.getAttribute("data-category") || "",
          categoryLabel: row.getAttribute("data-category-label") || "",
          image: row.getAttribute("data-image") || "",
          price: price,
          priceLabel: row.getAttribute("data-price-label") || "",
          available: row.getAttribute("data-available") === "1",
        };
      }

      function detectQuestionIntent(question) {
        var q = String(question || "").toLowerCase().replace(/’/g, "'");
        if (!q) return "product";
        if (/zwanger|pregnant|medicatie|medicijn|medication|ziekte|borstvoeding|breastfeeding|bloedverdunner|diagnose|geneest|\bcure\b|disease/i.test(q)) {
          return "product";
        }
        var aboutSelected =
          /\b(dit product|zit hier|hoe gebruik ik dit|hoe gebruik ik het geselecteerde|bevat dit|is dit |van dit product|this product|does this|is this |how do i use this|how do i use the selected|selected product)\b/i.test(
            q
          );
        var catalogCue =
          /ik zoek|i'm looking|i am looking|looking for|welke producten|which products|welke creatine|which creatine|welke eiwit|which protein|onder €|onder \d+|under €|under \d+|op voorraad|in stock|goedkoopst|cheapest|ik wil iets|find a product|bevatten magnesium|contain magnesium|zonder suiker|without sugar|zonder cafe|laat .+ zien/i.test(
            q
          );
        if (aboutSelected && !catalogCue) return "product";
        if (catalogCue && !aboutSelected) return "catalog";
        if (aboutSelected) return "product";
        return "product";
      }

      function parseCatalogQuery(question) {
        var q = String(question || "").toLowerCase();
        var category = "";
        var categoryLabel = "";
        if (/eiwit|protein|whey|proteine/.test(q)) {
          category = "eiwitten";
          categoryLabel = isEnglish() ? "Proteins" : "Eiwitten";
        } else if (/creatine/.test(q)) {
          category = "creatine";
          categoryLabel = "Creatine";
        } else if (/pre[- ]?workout|preworkout/.test(q)) {
          category = "pre-workout";
          categoryLabel = "Pre-workout";
        } else if (/vetverbrander|fat burner|afslank/.test(q)) {
          category = "vetverbranders-afslanken";
          categoryLabel = isEnglish() ? "Fat Burners & Weight Loss" : "Vetverbranders & Afslanken";
        } else if (/vitamine|vitamin|mineraal|mineral/.test(q) && !/magnesium/.test(q)) {
          category = "vitaminen-mineralen";
          categoryLabel = isEnglish() ? "Vitamins & Minerals" : "Vitaminen & Mineralen";
        } else if (/amino/.test(q)) {
          category = "aminozuren";
          categoryLabel = isEnglish() ? "Amino Acids" : "Aminozuren";
        } else if (/\bvoeding\b|\bnutrition\b/.test(q) && !/voedingswaarde|nutrition facts/.test(q)) {
          category = "voeding";
          categoryLabel = isEnglish() ? "Nutrition" : "Voeding";
        } else if (/gezondheid|\bhealth\b/.test(q)) {
          category = "gezondheid";
          categoryLabel = isEnglish() ? "Health" : "Gezondheid";
        }
        var priceLte = null;
        var priceM = q.match(/(?:onder|under|below|max(?:imum)?|tot)\s*€?\s*(\d+(?:[.,]\d+)?)/i);
        if (priceM) priceLte = Number(String(priceM[1]).replace(",", "."));
        var cheapest = /goedkoopst|cheapest|lowest price/i.test(q);
        var inStock = /op voorraad|in stock|available/i.test(q);
        var unverified = [];
        if (/vegan|vegetar/i.test(q)) unverified.push(isEnglish() ? "vegan/vegetarian" : "vegan/vegetarisch");
        if (/zonder suiker|without sugar|sugar[- ]free|suikervrij|no added sugar/i.test(q)) unverified.push(isEnglish() ? "sugar-free" : "suikervrij");
        if (/cafe[iï]ne|caffeine/i.test(q)) unverified.push(isEnglish() ? "caffeine" : "cafeïne");
        if (/gluten/i.test(q)) unverified.push(isEnglish() ? "gluten-free" : "glutenvrij");
        if (/lactose/i.test(q)) unverified.push(isEnglish() ? "lactose-free" : "lactosevrij");
        if (/magnesium/i.test(q)) unverified.push("magnesium");
        if (/poeder|powder|capsule|gummy|gummies|tablet/i.test(q)) unverified.push(isEnglish() ? "product form" : "productvorm");
        return {
          category: category,
          categoryLabel: categoryLabel,
          priceLte: priceLte,
          cheapest: cheapest,
          inStock: inStock,
          unverified: unverified,
        };
      }

      function renderResultList(items, reasonFor) {
        if (!thread || !items.length) return;
        var wrap = document.createElement("div");
        wrap.className = "mpg-aio-milo__results";
        items.forEach(function (item) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "mpg-aio-milo__result";
          btn.setAttribute("data-mpg-aio-milo-select", item.handle);
          var img = "";
          if (item.image) {
            img = '<img class="mpg-aio-milo__result-img" src="' + item.image.replace(/"/g, "") + '" alt="" width="40" height="40">';
          }
          var meta = [item.vendor, item.priceLabel].filter(Boolean).join(" · ");
          var reason = reasonFor(item);
          btn.innerHTML =
            img +
            '<span class="mpg-aio-milo__result-body">' +
            '<span class="mpg-aio-milo__result-title"></span>' +
            (meta ? '<span class="mpg-aio-milo__result-meta"></span>' : "") +
            (reason ? '<span class="mpg-aio-milo__result-reason"></span>' : "") +
            "</span>";
          btn.querySelector(".mpg-aio-milo__result-title").textContent = item.title;
          var metaEl = btn.querySelector(".mpg-aio-milo__result-meta");
          if (metaEl) metaEl.textContent = meta;
          var reasonEl = btn.querySelector(".mpg-aio-milo__result-reason");
          if (reasonEl) reasonEl.textContent = (COPY.match ? COPY.match + ": " : "") + reason;
          wrap.appendChild(btn);
        });
        wrap.addEventListener("click", function (event) {
          var btn = event.target.closest("[data-mpg-aio-milo-select]");
          if (!btn) return;
          var handle = btn.getAttribute("data-mpg-aio-milo-select") || "";
          var row = findRow(handle);
          if (row) selectRow(row, { history: "push" });
        });
        thread.appendChild(wrap);
        thread.scrollTop = thread.scrollHeight;
      }

      function runCatalogSearch(question) {
        var parsed = parseCatalogQuery(question);
        var hasVerified = !!(parsed.category || parsed.priceLte != null || parsed.cheapest || parsed.inStock);
        if (parsed.unverified.length) {
          miloNote(COPY.catalogNote + " (" + parsed.unverified.join(", ") + ")");
        }
        if (!hasVerified) {
          miloNote(COPY.catalogBlocked);
          return;
        }
        var items = rows.map(catalogItem).filter(Boolean);
        if (parsed.category) {
          items = items.filter(function (item) {
            return item.category === parsed.category;
          });
        }
        if (parsed.priceLte != null) {
          items = items.filter(function (item) {
            return item.price != null && item.price <= parsed.priceLte;
          });
        }
        if (parsed.inStock) {
          items = items.filter(function (item) {
            return item.available;
          });
        }
        if (parsed.cheapest) {
          items = items
            .filter(function (item) {
              return item.price != null;
            })
            .sort(function (a, b) {
              return a.price - b.price;
            });
        }
        items = items.slice(0, 8);
        if (!items.length) {
          miloNote(COPY.catalogBlocked);
          return;
        }
        renderResultList(items, function (item) {
          var bits = [];
          if (parsed.category && item.categoryLabel) bits.push(item.categoryLabel);
          if (parsed.priceLte != null && item.priceLabel) bits.push(item.priceLabel);
          if (parsed.inStock && item.available) bits.push(COPY.available);
          return bits.join(" · ");
        });
      }

      function waitForMilo(tries) {
        if (window.MuskleMilo && typeof window.MuskleMilo.ask === "function") {
          return Promise.resolve(window.MuskleMilo);
        }
        if (tries <= 0) return Promise.resolve(null);
        return new Promise(function (resolve) {
          setTimeout(function () {
            waitForMilo(tries - 1).then(resolve);
          }, 50);
        });
      }

      function syncEngineContext() {
        if (!window.MuskleMilo || !selectedRow) return;
        var facts = currentPgFacts || readProductgidsFacts(guideRoot);
        window.MuskleMilo.setProductContext({
          handle: selectedRow.getAttribute("data-handle") || "",
          title: selectedRow.getAttribute("data-title") || "",
          productgids: facts,
        });
      }

      function postProcessAnswer(action, response) {
        var text = (response && response.text) || "";
        var debug = (response && response.debug) || {};
        if (debug.productgids) return text;
        if (action === "allergens") {
          if (/bevat geen|does not contain|allergen[- ]free|geen allergen/i.test(text) || !debug.verifiedIngredients) {
            return COPY.allergenUnknown;
          }
          return text + " " + COPY.allergenUnknown;
        }
        if (action === "ingredients") {
          if (!debug.verifiedIngredients) return text + (text ? " " : "") + COPY.flavour;
          return text + " " + COPY.flavour;
        }
        if (action === "nutrition") {
          if (!debug.verifiedNutrition) {
            return COPY.nutritionLimited;
          }
          return text;
        }
        return text;
      }

      function askMilo(question, opts) {
        opts = opts || {};
        var q = String(question || "").trim();
        if (!q || asking) return;
        if (!opts.silentUser) miloNote(q, "user");
        asking = true;
        syncEngineContext();
        waitForMilo(40)
          .then(function (engine) {
            if (!engine) {
              setMiloStatus("error");
              miloNote(unavailableLabel, "error");
              return null;
            }
            return engine.ask(q);
          })
          .then(function (result) {
            if (!result) return;
            if (!result.ok) {
              setMiloStatus("error");
              miloNote(
                (result.source === "render" && result.response && result.response.text) || errorLabel,
                "error"
              );
              return;
            }
            setMiloStatus("ready");
            var response = result.response || {};
            var text;
            if (result.source === "render") {
              text = response.text || errorLabel;
            } else {
              text = opts.action ? postProcessAnswer(opts.action, response) : response.text || errorLabel;
            }
            miloNote(text || errorLabel, text ? "" : "error");
          })
          .catch(function () {
            setMiloStatus("error");
            miloNote(errorLabel, "error");
          })
          .then(function () {
            asking = false;
            syncEngineContext();
          });
      }

      if (toggle && body) {
        toggle.addEventListener("click", function () {
          var open = body.classList.toggle("is-open");
          toggle.setAttribute("aria-expanded", open ? "true" : "false");
        });
      }

      var banner = milo.querySelector(".mpg-aio-milo__banner");
      var sticky = milo.querySelector(".mpg-aio-milo__sticky");
      if (banner && sticky && "IntersectionObserver" in window) {
        var desktopMq = window.matchMedia("(min-width: 1100px)");
        var heroObserver = new IntersectionObserver(
          function (entries) {
            if (!desktopMq.matches) {
              sticky.classList.remove("is-stuck");
              return;
            }
            var visible = entries[0] && entries[0].isIntersecting;
            sticky.classList.toggle("is-stuck", !visible);
          },
          { rootMargin: "-80px 0px 0px 0px", threshold: 0 }
        );
        heroObserver.observe(banner);
      }

      waitForMilo(40).then(function (engine) {
        if (!engine) {
          setMiloStatus("error");
          return;
        }
        setMiloStatus("ready");
        syncEngineContext();
      });

      milo.querySelectorAll("[data-mpg-aio-milo-chip]").forEach(function (chip) {
        chip.addEventListener("click", function () {
          milo.querySelectorAll("[data-mpg-aio-milo-chip]").forEach(function (c) {
            c.classList.toggle("is-active", c === chip);
          });
          var action = chip.getAttribute("data-mpg-aio-milo-chip") || "";
          if (action === "usage" || action === "ingredients" || action === "nutrition" || action === "warnings" || action === "allergens") {
            scrollToGuideTopic(action === "allergens" ? "ingredients" : action);
            askMilo(CHIP_Q[action] || "", { action: action });
          }
        });
      });

      function hasSelectedProduct() {
        var handle = selectedRow ? selectedRow.getAttribute("data-handle") || "" : "";
        return !!handle;
      }

      function syncSelectedProductInputGate() {
        var notice = milo.querySelector("[data-mpg-aio-milo-lock-notice]");
        if (notice) notice.hidden = true;
        if (!input) return;
        if (hasSelectedProduct()) {
          input.removeAttribute("readonly");
          input.removeAttribute("aria-readonly");
          input.setAttribute("inputmode", "text");
          return;
        }
        input.value = "";
        input.setAttribute("readonly", "readonly");
        input.setAttribute("aria-readonly", "true");
        input.setAttribute("inputmode", "none");
      }

      function submitSelectedProductQuestion() {
        if (!hasSelectedProduct() || !input) return;
        var q = String(input.value || "").trim();
        if (!q) return;
        askMilo(q);
        input.value = "";
      }

      function showFreeQuestionLock() {
        if (hasSelectedProduct()) return;
        var notice = milo.querySelector("[data-mpg-aio-milo-lock-notice]");
        if (!notice) return;
        notice.hidden = false;
        if (input) {
          input.value = "";
          try {
            input.blur();
          } catch (e) {}
        }
        if (showFreeQuestionLock.timer) clearTimeout(showFreeQuestionLock.timer);
        showFreeQuestionLock.timer = setTimeout(function () {
          notice.hidden = true;
        }, 4000);
      }

      function hideFreeQuestionLock(event) {
        var notice = milo.querySelector("[data-mpg-aio-milo-lock-notice]");
        if (!notice || notice.hidden) return;
        if (event && event.target && milo.querySelector(".mpg-aio-milo__composer-wrap") && milo.querySelector(".mpg-aio-milo__composer-wrap").contains(event.target)) {
          return;
        }
        notice.hidden = true;
      }

      if (send) {
        send.addEventListener("click", function (event) {
          event.preventDefault();
          if (hasSelectedProduct()) {
            submitSelectedProductQuestion();
            return;
          }
          showFreeQuestionLock();
        });
      }
      if (input) {
        syncSelectedProductInputGate();
        ["focus", "click", "pointerdown", "touchstart"].forEach(function (type) {
          input.addEventListener(
            type,
            function (event) {
              if (hasSelectedProduct()) return;
              event.preventDefault();
              showFreeQuestionLock();
            },
            { passive: false }
          );
        });
        input.addEventListener("keydown", function (event) {
          if (hasSelectedProduct()) {
            if (event.key === "Enter") {
              event.preventDefault();
              submitSelectedProductQuestion();
            }
            return;
          }
          event.preventDefault();
          showFreeQuestionLock();
        });
      }
      document.addEventListener("click", hideFreeQuestionLock);

      root.addEventListener("mpg-aio-milo-product-change", function (event) {
        var handle = event.detail && event.detail.handle ? event.detail.handle : "";
        if (lastHandle && handle && lastHandle !== handle) {
          if (thread) thread.innerHTML = "";
          miloNote(changedLabel);
        }
        lastHandle = handle;
        syncEngineContext();
        syncSelectedProductInputGate();
      });
    }

    function selectRow(row, opts) {
      if (!row) return;
      opts = opts || {};
      selectedRow = row;
      rows.forEach(function (r) {
        var on = r === row;
        r.classList.toggle("is-selected", on);
        r.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (!opts.skipShowPage) showPageForRow(row);
      loadGuide(row);
      updateMiloContext(row);
      root.dispatchEvent(
        new CustomEvent("mpg-aio-milo-product-change", {
          detail: {
            handle: row.getAttribute("data-handle") || "",
            title: row.getAttribute("data-title") || "",
          },
        })
      );
      if (!applyingUrl && opts.history !== "none") {
        syncUrl(opts.history === "replace" ? "replace" : "push");
      }
    }

    var creatinePromo = root.querySelector("[data-mpg-aio-creatine-promo]");
    var creatinePromoClose = root.querySelector("[data-mpg-aio-creatine-promo-close]");
    var creatinePromoDismissed = false;

    function hideCreatinePromo() {
      if (!creatinePromo) return;
      creatinePromo.hidden = true;
    }

    function showCreatinePromo() {
      if (!creatinePromo) return;
      creatinePromo.hidden = false;
    }

    catButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var slug = btn.getAttribute("data-mpg-aio-cat") || "";
        var wasCreatine = activeCat === "creatine";
        var nowCreatine = slug === "creatine";
        setCategory(slug);
        if (!nowCreatine) {
          creatinePromoDismissed = false;
          hideCreatinePromo();
        } else if (!wasCreatine) {
          creatinePromoDismissed = false;
          showCreatinePromo();
        }
      });
    });

    if (search) {
      search.addEventListener("input", function () {
        query = (search.value || "").toLowerCase().trim();
        page = 1;
        renderPager();
        syncGuidePrevNext(guideRoot);
        if (!applyingUrl) syncUrl("replace");
      });
    }

    if (reset) {
      reset.addEventListener("click", function () {
        if (search) search.value = "";
        query = "";
        setCategory("");
        creatinePromoDismissed = false;
        hideCreatinePromo();
      });
    }

    if (creatinePromoClose) {
      creatinePromoClose.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        creatinePromoDismissed = true;
        hideCreatinePromo();
      });
    }

    rows.forEach(function (row) {
      row.addEventListener("click", function () {
        if (selectedRow === row) {
          syncUrl("replace");
          return;
        }
        selectRow(row, { history: "push" });
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        page -= 1;
        renderPager();
        if (!applyingUrl) syncUrl("replace");
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        page += 1;
        renderPager();
        if (!applyingUrl) syncUrl("replace");
      });
    }
    if (pageNums) {
      pageNums.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-mpg-aio-page]");
        if (!btn) return;
        page = Number(btn.getAttribute("data-mpg-aio-page")) || 1;
        renderPager();
        if (!applyingUrl) syncUrl("replace");
      });
    }

    function restoreFromUrl() {
      var state = readUrlState();
      query = (state.search || "").toLowerCase().trim();
      if (search) search.value = state.search || "";
      applyCategory(state.cat || "", false);
      if (state.page >= 1) page = state.page;

      var row = findRow(state.product) || findRow(defaultHandle);
      if (!row) {
        row =
          rows.filter(function (r) {
            return r.getAttribute("data-guide-ready") === "1";
          })[0] || rows[0];
      }

      renderPager();
      if (row) {
        var matches = matchingRows();
        var idx = matches.indexOf(row);
        if (idx >= 0) {
          var start = (page - 1) * PER_PAGE;
          var onThisPage = idx >= start && idx < start + PER_PAGE;
          if (!onThisPage) page = Math.floor(idx / PER_PAGE) + 1;
        }
        renderPager();
        selectRow(row, { history: "none", skipShowPage: true });
      }
      creatinePromoDismissed = false;
      hideCreatinePromo();
      syncUrl("replace");
    }

    window.addEventListener("popstate", function () {
      applyingUrl = true;
      restoreFromUrl();
      applyingUrl = false;
    });

    document.addEventListener("cart:update", function (event) {
      var cart = event && event.detail && event.detail.resource;
      if (cart && Array.isArray(cart.items)) {
        applyCart(cart);
        paintCtas();
        return;
      }
      refreshCart();
    });

    bindMilo();
    refreshCart();
    applyingUrl = true;
    restoreFromUrl();
    applyingUrl = false;
  });
})();
